import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const ActionButtonsStyles = styled.div`
  .request-info-button {
    order: 1;
  }
  .find-retailer-button {
    order: 2;

    > span {
      display: flex;
      font-family: 'source-sans-pro', sans-serif;
      max-width: 150px;
    }
    svg {
      margin-top: 1px;

      path {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    display: flex;
    flex-wrap: wrap;
    max-width: 215px;

    .request-info-button {
      order: 2;
    }
    .find-retailer-button {
      order: 1;
    }
  }
`;
